import { render, staticRenderFns } from "./basicDialog.vue?vue&type=template&id=36513963&scoped=true"
import script from "./basicDialog.vue?vue&type=script&lang=js"
export * from "./basicDialog.vue?vue&type=script&lang=js"
import style0 from "./basicDialog.vue?vue&type=style&index=0&id=36513963&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36513963",
  null
  
)

export default component.exports